import { Alert, List } from '@pella/sash-framework';
import PropTypes from 'prop-types';
import React from 'react';
//TODO: add this to the sash framework
const AlertList = ({ errors, className }) => {
	return (
		errors?.length > 0 && (
			<Alert
				type='error'
				hideClose
				className={className}
				id='alert-list'
			>
				<List bullets='none'>
					{errors.map((error, index) => {
						const key = Object.keys(error)[0];
						return (
							<li
								key={index}
								dangerouslySetInnerHTML={{ __html: error[key] }}
								className='[&_a]:decoration-red '
							/>
						);
					})}
				</List>
			</Alert>
		)
	);
};

AlertList.propTypes = {
	errors: PropTypes.array.isRequired,
	className: PropTypes.string,
};

export default AlertList;
